import { isNil } from 'lodash';
import React from 'react';

interface IProps {
  children: (show: boolean) => any;
  scrollMargin?: number;
  trackerId?: string;
}

export default class SneakyElement extends React.Component<IProps> {
  public state = {
    element: null,
    top: undefined,
  };

  public componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    const { trackerId } = this.props;
    if (trackerId && typeof window !== 'undefined') {
      const trackers = (window as any).odSneakyTrackers || {};
      this.setState({ element: trackers[trackerId] });
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    const show = !isNil(this.state.top) && this.state.top <= (-this.props.scrollMargin || 0);
    if (this.props.trackerId) {
      return this.props.children(show);
    }
    return <div ref={this.setElement}>{this.props.children(show)}</div>;
  }

  private setElement = element => this.setState({ element });

  private handleScroll = event => {
    const top = !isNil(this.state.element) && this.state.element.getBoundingClientRect().top;
    this.setState({ top });
  };
}
